(() => {
  const closest = (el, sel) => (el && el.closest ? el.closest(sel) : null);

  async function addToCart(variantId, qty = 1) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: qty }),
    });

    if (!res.ok) {
      let msg = 'Falha ao adicionar no carrinho.';
      try {
        const data = await res.json();
        msg = data?.description || data?.message || msg;
      } catch (_) {}
      throw new Error(msg);
    }

    return res.json();
  }

  function getSectionIdFromDrawer() {
    const el = document.querySelector('cart-items-component[data-section-id]');
    return el?.getAttribute('data-section-id') || null;
  }

  async function refreshDrawerBySectionId() {
    const sectionId = getSectionIdFromDrawer();
    if (!sectionId) return;

    const url = `/?sections=${encodeURIComponent(sectionId)}`;
    const res = await fetch(url, { headers: { 'Accept': 'application/json' } });
    if (!res.ok) return;

    const json = await res.json();
    const html = json[sectionId];
    if (!html) return;

    const doc = new DOMParser().parseFromString(html, 'text/html');

    const newInner = doc.querySelector('.cart-drawer__inner');
    const curInner = document.querySelector('.cart-drawer__inner');

    if (newInner && curInner) {
      curInner.replaceWith(newInner);
    }

    const newBubble =
      doc.querySelector('#cart-icon-bubble') ||
      doc.querySelector('.cart-count-bubble') ||
      doc.querySelector('[data-cart-count]');
    const curBubble =
      document.querySelector('#cart-icon-bubble') ||
      document.querySelector('.cart-count-bubble') ||
      document.querySelector('[data-cart-count]');

    if (newBubble && curBubble) {
      curBubble.replaceWith(newBubble);
    }
  }

  // ---------- AUTOPLAY --------------------------------------------------
  // Intervalo em ms entre cada avanço automático
  const AUTOPLAY_INTERVAL = 3000;

  // Guarda os timers por track (WeakMap evita memory leak)
  const autoplayTimers = new WeakMap();

  function getItems(track) {
    return Array.from(track.querySelectorAll('[data-upsell-item]'));
  }

  function getCurrentIndex(track) {
    const items = getItems(track);
    if (!items.length) return 0;
    // Considera o item mais próximo do início do scroll como "atual"
    const trackLeft = track.getBoundingClientRect().left;
    let best = 0;
    let bestDist = Infinity;
    items.forEach((item, i) => {
      const dist = Math.abs(item.getBoundingClientRect().left - trackLeft);
      if (dist < bestDist) { bestDist = dist; best = i; }
    });
    return best;
  }

  function scrollToIndex(track, index) {
    const items = getItems(track);
    if (!items[index]) return;
    const item = items[index];
    // Calcula a posição relativa dentro do track
    const trackScrollLeft = track.scrollLeft;
    const trackLeft = track.getBoundingClientRect().left;
    const itemLeft = item.getBoundingClientRect().left;
    const targetScroll = trackScrollLeft + (itemLeft - trackLeft);
    track.scrollTo({ left: targetScroll, behavior: 'smooth' });
  }

  function startAutoplay(track) {
    stopAutoplay(track);
    const timer = setInterval(() => {
      const items = getItems(track);
      if (!items.length) return;

      const chegouAoFim = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      if (chegouAoFim) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
        return;
      }

      const current = getCurrentIndex(track);
      const next = current + 1 >= items.length ? 0 : current + 1;
      scrollToIndex(track, next);
    }, AUTOPLAY_INTERVAL);
    autoplayTimers.set(track, timer);
  }

  function stopAutoplay(track) {
    const timer = autoplayTimers.get(track);
    if (timer) {
      clearInterval(timer);
      autoplayTimers.delete(track);
    }
  }

  function initAutoplay(root) {
    const track = root.querySelector('[data-upsell-track]');
    if (!track) return;

    const items = getItems(track);
    // Só ativa autoplay se houver mais de 1 item
    if (items.length <= 1) return;

    startAutoplay(track);

    // Pause no hover (desktop)
    root.addEventListener('mouseenter', () => stopAutoplay(track));
    root.addEventListener('mouseleave', () => startAutoplay(track));

    // Pause no touch (mobile): para quando toca, retoma quando solta
    track.addEventListener('touchstart', () => stopAutoplay(track), { passive: true });
    track.addEventListener('touchend', () => {
      // Pequeno delay para não reiniciar logo após o swipe
      setTimeout(() => startAutoplay(track), 1200);
    }, { passive: true });

    // Pausa também se o usuário usar as setas manualmente
    root.addEventListener('click', (e) => {
      if (e.target.closest('[data-upsell-prev]') || e.target.closest('[data-upsell-next]')) {
        stopAutoplay(track);
        // Retoma após 4s de inatividade
        setTimeout(() => startAutoplay(track), 4000);
      }
    });
  }

  // Inicializa autoplay em todos os upsell roots presentes + observa novos (ex: após refresh do drawer)
  function attachAutoplayToAll() {
    document.querySelectorAll('[data-cart-upsells]').forEach(initAutoplay);
  }

  // MutationObserver para reinicializar após o drawer ser re-renderizado
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        // Se o próprio nó é um upsell root
        if (node.matches?.('[data-cart-upsells]')) {
          initAutoplay(node);
        }
        // Ou se contém upsell roots dentro
        node.querySelectorAll?.('[data-cart-upsells]').forEach(initAutoplay);
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Inicialização na primeira carga (ex: se o drawer já estiver aberto)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachAutoplayToAll);
  } else {
    attachAutoplayToAll();
  }
  // ---------- FIM AUTOPLAY ----------------------------------------------


  // SETAS (capture phase pra evitar bloqueio do tema)
  document.addEventListener(
    'click',
    (e) => {
      const prevBtn = closest(e.target, '[data-upsell-prev]');
      const nextBtn = closest(e.target, '[data-upsell-next]');
      if (!prevBtn && !nextBtn) return;

      const root = closest(e.target, '[data-cart-upsells]');
      const track = root && root.querySelector('[data-upsell-track]');
      if (!track) return;

      e.preventDefault();
      e.stopPropagation();

      const step = Math.min(320, track.clientWidth * 0.9) || 280;
      track.scrollBy({ left: prevBtn ? -step : step, behavior: 'smooth' });
    },
    true
  );

  // ADD
  document.addEventListener(
    'click',
    async (e) => {
      const addBtn = closest(e.target, '[data-upsell-add]');
      if (!addBtn) return;

      const item = closest(addBtn, '[data-upsell-item]');
      const variantEl = item && item.querySelector('[data-upsell-variant]');
      const variantId = variantEl && (variantEl.value || variantEl.getAttribute('value'));
      if (!variantId) return;

      e.preventDefault();
      e.stopPropagation();

      const defaultText = addBtn.getAttribute('data-default-text') || 'Adicionar';

      try {
        addBtn.classList.add('is-loading');
        addBtn.textContent = 'Carregando';

        await addToCart(variantId, 1);

        await refreshDrawerBySectionId();

        addBtn.textContent = 'Adicionado ✓';
        setTimeout(() => (addBtn.textContent = defaultText), 1200);
      } catch (err) {
        console.error(err);
        addBtn.textContent = 'Erro';
        setTimeout(() => (addBtn.textContent = defaultText), 1500);
      } finally {
        addBtn.classList.remove('is-loading');
      }
    },
    true
  );

  // ---------- UPSELL: valida seleção antes de adicionar
  document.addEventListener('click', function (e) {
    const addBtn = e.target.closest('[data-upsell-add]');
    if (!addBtn) return;

    const item = addBtn.closest('[data-upsell-item]');
    if (!item) return;

    const select = item.querySelector('select[data-upsell-variant]');
    if (!select) return;

    if (!select.value) {
      e.preventDefault();

      select.classList.add('is-error', 'is-shake');

      setTimeout(() => {
        select.classList.remove('is-shake');
      }, 300);

      select.focus();
      return;
    }

    select.classList.remove('is-error');
  });

  document.addEventListener('change', function (e) {
    const select = e.target.closest('select[data-upsell-variant]');
    if (!select) return;

    select.classList.remove('is-error');
  });

})();